import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden bg-slate-900"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: "url(/img/hero-parking-lot.jpg)",
        }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/85 to-slate-900/40" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-36 lg:py-44">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-500/15 border border-orange-400/30 text-orange-300 text-xs font-bold tracking-[0.2em] uppercase">
            <MapPin className="h-3.5 w-3.5" />
            Memphis · Mid-South
          </div>

          <h1
            data-testid="hero-heading"
            className="mt-6 font-display font-black tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
          >
            Parking lots that look{" "}
            <span className="text-orange-400">like new</span> — without
            shutting you down.
          </h1>

          <p className="mt-6 text-lg sm:text-xl text-slate-200 leading-relaxed max-w-xl">
            Professional striping, sealcoating, and ADA pavement marking
            for retail centers, offices, churches, and HOAs across Memphis
            and the Mid-South.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Button
              asChild
              size="lg"
              data-testid="hero-quote-cta"
              className="bg-orange-600 hover:bg-orange-700 text-white font-semibold text-base px-7 py-6 rounded-md"
            >
              <Link to="/quote">
                Get a Free Quote
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              data-testid="hero-services-cta"
              className="bg-transparent text-white border-white/40 hover:bg-white hover:text-slate-900 font-semibold text-base px-7 py-6 rounded-md"
            >
              <Link to="/services">See Our Services</Link>
            </Button>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-slate-300">
            <div className="flex items-center gap-2">
              <ShieldCheck className="h-4 w-4 text-orange-400" />
              Licensed & insured
            </div>
            <div className="flex items-center gap-2">
              <ShieldCheck className="h-4 w-4 text-orange-400" />
              After-hours crews
            </div>
            <div className="flex items-center gap-2">
              <ShieldCheck className="h-4 w-4 text-orange-400" />
              ADA-compliant work
            </div>
          </div>
        </div>
      </div>

      <div className="stripe-divider relative" aria-hidden="true" />
    </section>
  );
}
